import { put, call, takeLatest } from "redux-saga/effects";
import { alertConstants, authConstants, adminAuditLogConstants } from "_constants";
import { adminAuditLogService } from "_services";

export function* getAuditLogsSaga(action) {
  try {
    const { section, startDate, endDate } = action;
    const response = yield call(adminAuditLogService.getAuditLogs, section, startDate, endDate);

    yield put({
      type: adminAuditLogConstants.GET_AUDIT_LOGS_SUCCESS,
      payload: [...response.logs],
    });
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({
        type: authConstants.LOGOUT,
      });
    }
    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}

export function* searchByUsernameSaga(action) {
  try {
    const { username, limit } = action;
    const response = yield call(adminAuditLogService.searchByUsername, username, limit);

    yield put({
      type: adminAuditLogConstants.SEARCH_BY_USERNAME_SUCCESS,
      payload: [...response.logs],
    });
  } catch (error) {
    if (error.message === "Invalid Auth Token") {
      yield put({
        type: authConstants.LOGOUT,
      });
    }
    yield put({
      type: alertConstants.ERROR,
      payload: { message: error.message },
    });
  }
}

export function* watchAdminAuditLog() {
  yield takeLatest(adminAuditLogConstants.GET_AUDIT_LOGS_REQUEST, getAuditLogsSaga);
  yield takeLatest(adminAuditLogConstants.SEARCH_BY_USERNAME_REQUEST, searchByUsernameSaga);
}
